import { IconInfo } from '@developerz/ui';
import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { Button, buttonClass } from './ui/Button';

// The shell's "another sign-in uses your email" banner (#7426 decision 2).
// Presenter: `<LinkCandidatesBanner/>` decides whether it shows and owns the
// dismissal. `role="status"`, not `alert`: a "when you have a minute" notice,
// the `KeyOutageBanner` reason, and it must not steal the page's focus.
//
// It FLOATS (`.link-notice`, fixed bottom-right on the overlay shadow, the
// `notice` layer) rather than sitting in the shell's flow: it appears only once
// `/v1/me/link-candidates` answers, after the page has laid out, and an in-flow
// card pushed every page down by its own height on arrival (#7430 CI: the
// Agents skeleton-to-loaded layout spec measured the shift at 104 px).

export function LinkCandidatesNotice(props: {
  readonly href: string;
  readonly onDismiss: () => void;
}): JSX.Element {
  return (
    <div class="alert alert--icon link-notice" role="status">
      <IconInfo />
      <p class="alert__title">{t('logins.banner_title')}</p>
      <p class="alert__desc">{t('logins.banner_desc')}</p>
      <div class="link-candidates-banner__actions">
        <A class={buttonClass({ variant: 'outline', size: 'sm' })} href={props.href}>
          {t('logins.banner_cta')}
        </A>
        <Button variant="ghost" size="sm" onClick={() => props.onDismiss()}>
          {t('logins.banner_dismiss')}
        </Button>
      </div>
    </div>
  );
}
